import { useState, useEffect } from "react";
import Sidebar from '../../../componente/sidebar/index.jsx';
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from '../../../context/AppContext.js';
import LoadingScreen from "../../../componente/aguarde";
import Impressora from "../../../assets/Impressora.png";
import Modal from "react-modal";

function RelProducaoFunc() {
    const [lista, setlista] = useState([]);
    const [listaDetalhe, setListaDetalhe] = useState([]);
    const [abusca, setabusca] = useState("");
    const [loading, setLoading] = useState(false);
    const [showform, setshowform] = useState(false);

    const dt = new Date();

    const date1 =
        dt.getFullYear() +
        "-" +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        dt.getDate().toString().padStart(2, "0");

    const date2 =
        dt.getFullYear() +
        "-" +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        dt.getDate().toString().padStart(2, "0");

    const [dt1, setdt1] = useState(date1);
    const [dt2, setdt2] = useState(date2);
    const [usuario, setUsuario] = useState(0);

    const { selectedCompany, accessKey } = useAppContext(); // Acessa os dados do contexto 

    async function ListarProducaoDetalhe(cad) {
        setLoading(true);        
        setUsuario(cad.nome);

        try {
            const response = await api.get("/v1/relatorio/producaofunc/listaproducaofunc", {
                params: {
                    codempresa: selectedCompany,
                    dt1,
                    dt2,
                    codusuario: cad.codusuario,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            setListaDetalhe(response.data);

            setshowform(true);
        } catch (error) {
            console.log("ops! ocorreu um erro: " + error);
        } finally {
            setLoading(false);
        }
    }

    function ListarProducao() {
        api
            .get("/v1/relatorio/producaofunc", {
                params: {
                    codempresa: selectedCompany,
                    dt1,
                    dt2,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarProducao();
        },
        [abusca, selectedCompany, dt1, dt2]
    );

    const imprimir = async () => {
        setLoading(true);

        try {
            const response = await api.get(`/v1/impressoes/relatorio/humor`, {
                responseType: "arraybuffer",
                params: {
                    busca: abusca,
                    codempresa: selectedCompany,
                    dt1,
                    dt2,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.log("ops! ocorreu um erro: " + error);
        } finally {
            setLoading(false);
        }
    };

    function closeModal() {
        setshowform(false);
    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <div className="content-container">
                    <div className="container-fluid">
                        <Modal
                            isOpen={showform}
                            onRequestClose={closeModal}
                            overlayClassName="modal-overlay"
                            className="modal-content modal-xl"
                        >
                            <div className="container-fluid h-100">
                                <div className="modal-header">
                                    <h2>Lista de produção de: {usuario}</h2>
                                    <button type="button" className="btn-close" onClick={closeModal}></button>
                                </div>

                                <div className="modal-body">
                                    <form>
                                        <div className="row">

                                        </div>

                                        <div className="row tabela">
                                            <table className="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Núm. Pedido</th>
                                                        <th>Cliente</th>
                                                        <th>Setor</th>
                                                        <th>Valor</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {listaDetalhe.map(function (item, index) {
                                                        return (
                                                            <tr key={index}>
                                                                <th>{item.numpedido}</th>
                                                                <th>{item.cliente}</th>
                                                                <th>{item.setor}</th>
                                                                <th>{parseFloat(item.valor).toLocaleString("pt-BR", {
                                                                    style: "currency",
                                                                    currency: "BRL",
                                                                })}</th>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <th colSpan={4}>Quantidade de Registros: {listaDetalhe.length}</th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </form>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-danger" onClick={closeModal}>
                                        Fechar
                                    </button>
                                </div>
                            </div>
                        </Modal>

                        <div className="row">
                            <h1 className="ms-4">Relatório de Produção dos Funcionários</h1>
                            <p className="ms-4">Relatório que lista os funcionários e suas produções por período</p>
                            <hr />
                        </div>

                        <div className="row">
                            <div className="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                                <label className="form-label" htmlFor="busca">
                                    Busque aqui
                                </label>
                                <input
                                    type="text"
                                    placeholder="Buscar por: Núm. Pedido ou Cliente"
                                    name="busca"
                                    id="busca"
                                    className="form-control me-3"
                                    value={abusca}
                                    onChange={(e) => setabusca(e.target.value)}
                                />
                            </div>

                            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                <label htmlFor="dtlancamento" className="form-label">
                                    Lançamento de
                                </label>
                                <input
                                    type="date"
                                    id="dtlancamento"
                                    className="form-control"
                                    placeholder="Dt. Lançamento"
                                    value={dt1}
                                    onChange={(e) => setdt1(e.target.value)}
                                />
                            </div>

                            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                <label htmlFor="dtlancamento" className="form-label">
                                    Para...
                                </label>
                                <input
                                    type="date"
                                    id="dtlancamento"
                                    className="form-control"
                                    placeholder="Dt. Lançamento"
                                    value={dt2}
                                    onChange={(e) => setdt2(e.target.value)}
                                />
                            </div>

                            <div className="col-xl-1 col-lg-1 col-md-6 col-sm-12 d-flex justify-content-center">
                                <button type="button" className="btn" onClick={imprimir}>
                                    <img src={Impressora} alt="Imprimir" />
                                    <label>Imprimir</label>
                                </button>
                                {loading && <LoadingScreen />}
                            </div>
                        </div>

                        <div className="row mt-3">
                            <hr />
                        </div>

                        <div className="row tabela">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Total</th>
                                        <th className="acao">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lista.map(function (item, index) {
                                        return (
                                            <tr key={index}>
                                                <th>{item.nome}</th>
                                                <th>{parseFloat(item.total).toLocaleString("pt-BR", {
                                                    style: "currency",
                                                    currency: "BRL",
                                                })}</th>

                                                <th>
                                                    <div className="d-flex justify-content-center">
                                                        <button
                                                            type="button"
                                                            className="btn fa-solid fa-eye"
                                                            onClick={() => ListarProducaoDetalhe(item)}
                                                        ></button>
                                                    </div>
                                                </th>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={3}>Quantidade de Registros: {lista.length}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RelProducaoFunc;
